var _defs, _path, _ellipse, _path2, _ellipse2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMutualFund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 266 231",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#004393;opacity:0.2;}.cls-1,.cls-2,.cls-9{isolation:isolate;}.cls-2{fill:#49b2ff;opacity:0.4;}.cls-3{fill:#0d30ba;}.cls-4{fill:#0d57ba;}.cls-5{fill:#15341a;}.cls-6{fill:#15561a;}.cls-7{fill:#33b871;}.cls-8{fill:#fff;}.cls-9{opacity:0.1;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.45,224.78q10.73-1.42,64.38-4.8c10.74-.76,21.46-.62,32.19-.9l32.2-.52,32.2.52c10.73.28,21.46,0,32.19.9l32.2,1.71c10.73,1.05,21.46,1.66,32.19,3.09-10.73,1.38-21.46,2-32.19,3l-32.2,1.71c-10.73.76-21.46.62-32.19.9l-32.2.57-32.2-.57c-10.73-.28-21.45,0-32.19-.9l-32.19-1.71c-10.73-.81-21.48-1.66-32.19-3Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 220.73,
    cy: 87.72,
    rx: 4.7,
    ry: 4.55,
    style: {
      fill: "rgb(47, 121, 218)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 103.4,
    cy: 2.84,
    rx: 2.94,
    ry: 2.84,
    style: {
      fill: "rgb(47, 121, 218)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 7.05,
    cy: 88.99,
    rx: 7.05,
    ry: 6.71,
    style: {
      fill: "rgb(47, 121, 218)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M181.57,42.55l-.19-32.2L149.6,19.08l10.71,7.62L116.23,71.83,88,45.09,7.05,135.92H9.52l78-71,29.88,28.65,55.45-57.34Z",
    style: {
      fill: "rgb(14, 72, 198)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.23,23.59l-8.45-5.94-5.18,1.43,10.71,7.55Zm9.66,7.47L117.44,88.41,87.56,59.75,7.05,135.92H9.52l78-71,29.88,28.64,55.45-57.34,8.68,6.37,0-5.13Z",
    style: {
      fill: "rgb(47, 121, 218)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M51.89,195.67,114.14,93.55l48.48,27.6L100.38,223.27Z",
    style: {
      fill: "rgb(7, 66, 34)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M149.2,129.47l-47.83,78.4a7.27,7.27,0,0,0-9.79,2.25L68,196.71a6.75,6.75,0,0,0-2.7-9.33L113.15,109a7.27,7.27,0,0,0,9.79-2.24l23.54,13.4a6.77,6.77,0,0,0,2.72,9.34Z",
    style: {
      fill: "rgb(24, 107, 31)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 107.26,
    cy: 158.43,
    rx: 12.88,
    ry: 12.45,
    style: {
      fill: "rgb(7, 66, 34)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 122.41,
    cy: 133.58,
    rx: 5.65,
    ry: 5.46,
    style: {
      fill: "rgb(7, 66, 34)"
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 92.11,
    cy: 183.28,
    rx: 5.65,
    ry: 5.46
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M103.79,152.27a.35.35,0,0,1,.41,0l.75.44a.23.23,0,0,1,.1.28,1.09,1.09,0,0,1-.08.15l-.92,1.51-.06.12h.09a2.77,2.77,0,0,1,1.18.11h.11a.16.16,0,0,0,.07-.07l.66-1.1c.14-.21.27-.25.49-.12l.66.37a.29.29,0,0,1,.12.46c-.21.36-.44.73-.67,1.09v.17a3.06,3.06,0,0,1,1,1.59,3.35,3.35,0,0,1,.07,1.51,4.33,4.33,0,0,1-.34,1.15l0,.13h.08l1.69-.33,1.79-.31,2.44-.38c.29-.07.42.09.42.33l-.84,1.38a.68.68,0,0,1-.39.27l-1.42.23-1.22.22-2.06.36-1.73.36a.39.39,0,0,1-.28-.05l-.89-.5a.28.28,0,0,1-.17-.2.34.34,0,0,1,.05-.26l.47-.76A4.19,4.19,0,0,0,106,159a1.89,1.89,0,0,0-.13-1.15,1.7,1.7,0,0,0-.32-.47l-.07.11-1.8,2.94-.09.13a.29.29,0,0,1-.33.06l-.83-.48a.23.23,0,0,1-.07-.32.27.27,0,0,1,.06-.1l1.72-2.8.07-.11h-.09a1.6,1.6,0,0,0-1,.36,3.52,3.52,0,0,0-.88,1c-.23.37-.47.75-.69,1.12-.13.22-.3.25-.53.1s-.55-.33-.83-.48a.31.31,0,0,1-.21-.35Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M72.44,176.09l106.47-58.81,27.92,47.21L100.36,223.3Z",
    style: {
      fill: "rgb(7, 66, 34)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M190.93,165.24l-81.8,45.18a7.07,7.07,0,0,0-4.25-3.3,7.36,7.36,0,0,0-5.41.56L86,184.74a6.75,6.75,0,0,0,2.46-9.43l81.79-45.19a7.09,7.09,0,0,0,4.24,3.31,7.39,7.39,0,0,0,5.42-.56l13.52,22.93a6.92,6.92,0,0,0-3.25,4.23A6.69,6.69,0,0,0,190.93,165.24Z",
    style: {
      fill: "rgb(24, 107, 31)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 139.64,
    cy: 170.28,
    rx: 12.88,
    ry: 12.45,
    style: {
      fill: "rgb(7, 66, 34)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 165.56,
    cy: 155.97,
    rx: 5.65,
    ry: 5.46,
    style: {
      fill: "rgb(7, 66, 34)"
    }
  }), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 113.73,
    cy: 184.6,
    rx: 5.65,
    ry: 5.46
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M139.8,163.28a.32.32,0,0,1,.36.19c.14.25.29.49.42.74a.21.21,0,0,1-.06.28l-.13.1-1.59.87-.1.07h.08a3,3,0,0,1,1,.68c.06.06.11.06.18,0l1.14-.64c.23-.12.35-.09.49.13l.37.65c.13.2.09.33-.12.45l-1.14.62c-.07.05-.09.08-.06.16a3,3,0,0,1,.1,1.86,3.46,3.46,0,0,1-.72,1.35,4.74,4.74,0,0,1-.89.84l-.11.08h.08l1.63.53,1.71.6,2.31.83a.31.31,0,0,1,.25.19.28.28,0,0,1-.05.29l-1.44.8a.6.6,0,0,1-.47.05l-1.36-.48-1.17-.4-1.94-.67-1.68-.52a.31.31,0,0,1-.22-.18c-.17-.28-.35-.57-.51-.86a.26.26,0,0,1-.05-.25.3.3,0,0,1,.18-.2l.8-.43a4.24,4.24,0,0,0,1.24-.94,1.77,1.77,0,0,0,.49-1,1.51,1.51,0,0,0-.05-.56l-.11,0-3.06,1.7-.16.07a.27.27,0,0,1-.31-.12l-.48-.8a.23.23,0,0,1,.1-.31.26.26,0,0,0,.1-.07l3-1.63.11-.06-.07-.06a1.73,1.73,0,0,0-1.07-.17,3.93,3.93,0,0,0-1.28.46c-.38.22-.78.43-1.18.64-.22.13-.37.07-.5-.17a6.63,6.63,0,0,0-.48-.81.32.32,0,0,1,0-.41Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M100.37,168.91H223v54.37H100.37Z",
    style: {
      fill: "rgb(7, 66, 34)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M208.79,216.3h-94.2a6.78,6.78,0,0,0-2-4.9,7.23,7.23,0,0,0-5-2.11V182.88a7,7,0,0,0,7-7h94.21a7,7,0,0,0,7,7v26.41A7,7,0,0,0,208.79,216.3Z",
    style: {
      fill: "rgb(24, 107, 31)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 161.68,
    cy: 196.09,
    rx: 12.88,
    ry: 12.45,
    style: {
      fill: "rgb(7, 66, 34)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 191.53,
    cy: 196.08,
    rx: 5.65,
    ry: 5.46,
    style: {
      fill: "rgb(7, 66, 34)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 131.84,
    cy: 196.09,
    rx: 5.65,
    ry: 5.46,
    style: {
      fill: "rgb(7, 66, 34)"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M165.42,190.08a.32.32,0,0,1,.21.34v.84a.23.23,0,0,1-.2.22h-2.1v.09a2.63,2.63,0,0,1,.48,1c0,.1.06.12.15.12h1.32c.26,0,.35.08.35.32v.76c0,.25-.1.32-.35.32H164c-.08,0-.11,0-.13.12a3.09,3.09,0,0,1-.88,1.68,4,4,0,0,1-1.31.83,5.53,5.53,0,0,1-1.2.29h-.14l0,.06c.37.41.77.82,1.14,1.24s.79.89,1.18,1.34,1.05,1.22,1.58,1.87a.27.27,0,0,1,.12.27.3.3,0,0,1-.19.24h-1.66a.6.6,0,0,1-.44-.19l-.91-1.06-.82-.93c-.46-.51-.91-1-1.38-1.53l-1.19-1.26a.32.32,0,0,1-.1-.26V196c0-.23.1-.33.35-.33h.9a4.52,4.52,0,0,0,1.59-.24,1.81,1.81,0,0,0,1-.69,1.26,1.26,0,0,0,.24-.51h-3.86a.25.25,0,0,1-.21-.24V193c0-.14.09-.21.24-.23h3.66v-.07a1.6,1.6,0,0,0-.84-.67,3.86,3.86,0,0,0-1.35-.22H158c-.26,0-.36-.12-.35-.39s0-.63,0-.93a.33.33,0,0,1,.21-.36l7.55-.06Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M100.38,223.29s-26.84-41.85-36.52-47.23l98.76-54.89-4.6,7.58L72.43,176.08l27.95,47.22Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M100.38,223.29S99,172.33,95.72,164l111.12.5-8.49,4.67-98-.26Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMutualFund);
export default __webpack_public_path__ + "static/media/MutualFund.096ba649b45cd8d8c205688f281ab589.svg";
export { ForwardRef as ReactComponent };